import { CSSProperties, FC } from 'react'

import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useTranslation } from 'react-i18next'

import { PageTemplate } from '../../PageTemplate'
import styles from './AllApps.module.scss'
import { AllAppsProps } from './AllApps.types'

const ANIM_DELAY_STAGE_1 = 0.6
const ANIM_DELAY_STAGE_2 = 0.2
const ANIM_DELAY_STAGE_1_CUTOFF_APP_COUNT = 4

export const AllApps: FC<AllAppsProps> = ({ setActivePage }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'product_tour.all_apps'
  })

  const { apps: allApps } = useAvailableApps()

  const apps = Object.values(allApps)
    .filter(app => app.name)
    .filter(app => app.placement.length)

  const getAppAnimDelay = (appIndex: number) =>
    Array.from({ length: appIndex })
      .map((_, i) => i)
      .reduce((prev, cur) => {
        if (cur + 1 <= ANIM_DELAY_STAGE_1_CUTOFF_APP_COUNT) {
          return prev + ANIM_DELAY_STAGE_1
        }
        return prev + ANIM_DELAY_STAGE_2
      }, 0)

  return (
    <PageTemplate
      className={styles.allApps}
      navigationProps={{
        currentPage: 2,
        buttonLabel: t('navigate'),
        setActivePage,
        animationDelay: getAppAnimDelay(apps.length - 1)
      }}
    >
      <div className={styles.texts}>
        <h1>{t('title')}</h1>
        <span>{t('description')}</span>
      </div>
      <div className={styles.apps}>
        {apps.map((app, i) => {
          return (
            <div
              key={app.path}
              className={styles.app}
              style={
                {
                  '--animation-duration': `${
                    i + 1 <= ANIM_DELAY_STAGE_1_CUTOFF_APP_COUNT
                      ? ANIM_DELAY_STAGE_1
                      : ANIM_DELAY_STAGE_2
                  }s`,
                  '--animation-delay': `${getAppAnimDelay(i)}s`
                } as CSSProperties
              }
            >
              <img src={app.icon} width={50} height={50} />

              <span className={styles.name}>{app.name}</span>
            </div>
          )
        })}
      </div>
    </PageTemplate>
  )
}
